import { render, staticRenderFns } from "./reportcardSetting.vue?vue&type=template&id=507b9912&scoped=true&"
import script from "./reportcardSetting.vue?vue&type=script&lang=js&"
export * from "./reportcardSetting.vue?vue&type=script&lang=js&"
import style0 from "./reportcardSetting.vue?vue&type=style&index=0&id=507b9912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b9912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VFlex,VIcon,VLayout,VTextField})
